export class UpdateLogSectorByIdSector{
  constructor(repository){
    this.repository=repository
  }
  async execute(FK_SECTOR,OFFSET){
    const resp= await this.repository.updateByIdSector(FK_SECTOR,OFFSET)
    return resp
  }
}
